export  function howWorkSlider() {
    $(".how-work-slider").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
		
        let swiperOptions = {
            watchOverflow: true,
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            spaceBetween: 10,
            slidesPerView: 1,
            // centeredSlides: true,
            // freeMode: true,
            navigation: {
                nextEl: `.${curSliderWrap.find(".swiper-button-next").attr("class")}`,
                prevEl: `.${curSliderWrap.find(".swiper-button-prev").attr("class")}`,
            },
            breakpoints: {
                568: {
                    slidesPerView: 1.2,
                },
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/howWorkSlider.js